<template>
  <div class="navbar-end ml-auto u-display--flex u-flex-align--center">
    <div class="modal" :class="{ 'is-active': showModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("areYouSure") }}</p>
          <button
            class="delete"
            @click="showModal = false"
            aria-label="close"
          ></button>
        </header>
        <section class="modal-card-body">
          {{ $t("loginStatus.wantToLogOut") }}
        </section>
        <footer class="modal-card-foot">
          <button @click="logout()" class="c-button c-button--primary mr-4">
            {{ $t("loginStatus.yesLogOut") }}
          </button>
          <button @click="showModal = false" class="c-button">
            {{ $t("no") }}
          </button>
        </footer>
      </div>
    </div>
    <a
      role="button"
      class="navbar-burger"
      aria-label="menu"
      aria-expanded="false"
      data-target="l4bNavBar"
      v-if="isLoggedIn"
      @click="toggleNavbar"
    >
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>

    <div
      class="navbar-item navbar-dropdown-custom"
      :class="isLoggedIn ? 'header-display--desktop-block' : ''"
    >
      <span class="navbar-dropdown-trigger u-text-color-white">
        {{ $t("nav.contact") }}
      </span>
      <div class="navbar-dropdown-content p-4">
        <p class="email">
          ✉️
          <a href="mailto:zakelijk@lookingforbooking.com"
            >zakelijk@lookingforbooking.com</a
          >
        </p>
        <hr />
        <p>
          📞 {{ $t("nav.contactPhone") }}
          <strong><a href="tel:+31503965050"> +31 (0)50-3695050</a></strong>
        </p>
        <hr />
        <p>
          <a
            :href="whatsAppUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="whatsapp-link"
            @click="trackWhatsApp"
          >
            <i class="fab fa-whatsapp"></i> {{ $t("nav.whatsappLabel") }}
          </a>
        </p>
      </div>
    </div>
    <div
      class="navbar-item navbar-dropdown-custom"
      :class="isLoggedIn ? 'header-display--desktop-block' : ''"
    >
      <span class="navbar-dropdown-trigger">
        <img
          :src="
            $i18n.locale == 'en'
              ? require('@/assets/images/icons/gb.png')
              : require('@/assets/images/icons/nl.png')
          "
          width="20"
        />
      </span>
      <div class="navbar-dropdown-content">
        <a
          class="dropdown-item pl-4 pr-4"
          @click="setLocale('en')"
          :class="{ 'is-active': $i18n.locale == 'en' }"
        >
          <img src="@/assets/images/icons/gb.png" width="20" />
          English
        </a>
        <a
          :class="{ 'is-active': $i18n.locale == 'nl' }"
          class="dropdown-item pl-4 pr-4"
          @click="setLocale('nl')"
        >
          <img src="@/assets/images/icons/nl.png" width="20" />
          Nederlands
        </a>
      </div>
    </div>
    <!-- <a class="dropdown-item" v-if="env != ''" :href="envSwitchUrl">
      {{ envSwitchText }}
    </a> -->

    <div
      class="dropdown is-right header-display--desktop-block"
      :class="{ 'is-active': isActive }"
      v-if="isLoggedIn"
    >
      <div class="dropdown-trigger" ref="dropdownTrigger" @click="toggleActive">
        <button
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          class="c-button c-button--ghost--white"
        >
          <div class="user-logo"></div>
          <span class="mr-2 dropdown-fullname"
            >{{ fullName ?? userName }}
          </span>
          <span class="icon is-small">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a href="/booking-rules" class="dropdown-item">
            {{ $t("bookingRules") }}
          </a>
          <hr class="dropdown-divider" />
          <a href="#" @click="refreshCompanyInfo()" class="dropdown-item">
            Ververs data
          </a>
          <a
            href="/userprofile"
            class="dropdown-item"
            v-if="enableFlightRequests || !isProd()"
          >
            {{ $t("profile.metamenuLink") }}
          </a>
          <hr class="dropdown-divider" v-if="managementPortalUrl" />
          <a
            v-if="managementPortalUrl"
            :href="managementPortalUrl"
            target="_blank"
            class="dropdown-item"
          >
            Managementportal
          </a>

          <hr class="dropdown-divider" />

          <a href="#" @click="showModal = true" class="dropdown-item"
            >{{ $t("loginStatus.logout") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHelper from "@/helpers/common.helper.js";

export default {
  data() {
    return {
      showModal: false,
      isActive: false,
      isLoggedIn: false,
      env: "",
      envSwitchUrl: "",
      envSwitchText: "",
      userName: "",
      enableFlightRequests: false
    };
  },
  mounted() {
    this.checkLoginStatus();
    document.body.addEventListener("click", (e) => {
      this.isActive = false;
    });
  },
  watch: {
    $route(to, from) {
      this.checkLoginStatus();
    }
  },
  computed: {
    fullName() {
      let companyInfo = JSON.parse(localStorage.companyInfo);

      return companyInfo?.fullName ? companyInfo?.fullName : null;
    },
    managementPortalUrl() {
      let companyInfo = JSON.parse(localStorage.companyInfo);
      return companyInfo?.managementPortalUrl
        ? companyInfo?.managementPortalUrl
        : null;
    },
    whatsAppUrl() {
      const message = encodeURIComponent(this.$t("nav.whatsappMessage"));
      return `https://wa.me/31503695050?text=${message}`;
    }
  },
  methods: {
    toggleNavbar(event) {
      if (event) event.preventDefault();

      const burger = document.querySelector(".navbar-burger");
      const navMenu = document.getElementById("l4bNavBar");

      if (burger && navMenu) {
        const isActive = burger.classList.contains("is-active");

        if (!isActive) {
          // If opening navbar, close MetaMenu dropdown
          if (this.$refs.metaMenu) {
            this.$refs.metaMenu.closeDropdown();
          }
          burger.classList.add("is-active");
          navMenu.classList.add("is-active");
        } else {
          burger.classList.remove("is-active");
          navMenu.classList.remove("is-active");
        }
      }
    },
    checkLoginStatus() {
      this.setEnvLabel();
      let userData = CommonHelper.isLoggedIn();
      if (userData) {
        let companyInfo = JSON.parse(localStorage.companyInfo);

        this.enableFlightRequests = companyInfo?.enableFlightRequests ?? true;

        this.isLoggedIn = true;
        this.userName = userData.userName;
      } else {
        this.isLoggedIn = false;
      }
    },
    setEnvLabel() {
      // let env = CommonHelper.getApiEnv();
      this.env = "";

      return; // Disable this feature for now

      // if (window.location.origin === "https://portal.lookingforbooking.com") {
      //   return;
      // }
      // if (env !== "prod") {
      //   this.env = ` - ${env}`;
      //   if (env === "test") {
      //     this.envSwitchUrl = window.location.origin + "/?env=staging";
      //     this.envSwitchText = "Switch naar staging";
      //   } else {
      //     this.envSwitchUrl = window.location.origin + "/?env=test";
      //     this.envSwitchText = "Switch naar test";
      //   }
      // }
    },
    setLocale(locale) {
      localStorage.locale = locale;
      this.$i18n.locale = locale;

      setTimeout(() => window.location.reload(), 500);
    },
    toggleActive(e) {
      this.isActive = !this.isActive;
      this.$emit("toggled", this.isActive);
      e.stopPropagation();
    },
    closeDropdown() {
      this.isActive = false;
    },
    async refreshCompanyInfo() {
      await CommonHelper.fetchCompanyInfo();
      localStorage.removeItem("theme");
      await this.injectCustomCss();
    },
    trackWhatsApp() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "whatsappContactClick",
        contactMethod: "whatsapp"
      });
    },
    logout() {
      CommonHelper.invalidateSession();
      this.showModal = false;
      setTimeout(() => {
        this.$router.go("/");
      }, 500);
    }
  }
};
</script>
